import { render, staticRenderFns } from "./post-form--default.vue?vue&type=template&id=b4212710&lang=pug&"
import script from "./post-form--default.vue?vue&type=script&lang=js&"
export * from "./post-form--default.vue?vue&type=script&lang=js&"
import style0 from "./post-form--default.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports